import { render, staticRenderFns } from "./FormItemSelectInventoryType.vue?vue&type=template&id=250c2f81&"
import script from "./FormItemSelectInventoryType.vue?vue&type=script&lang=js&"
export * from "./FormItemSelectInventoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports